import { AttachmentFragment } from '@spotify/confidence-graphql';
import { useSegment } from '@spotify/plugin-confidence-flags-react';

import { parseSegmentName } from '../resourceUri';

export const useResolvedSegmentName = (
  artifact: AttachmentFragment,
): string | undefined => {
  const name = parseSegmentName(artifact.uri);
  const { segment } = useSegment({ name: name ?? '', skip: !name });
  return segment?.displayName ?? undefined;
};
